import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

const SUCCESS = 'AUDIENCE_HUB_SUCCESS';
const FAILURE = 'AUDIENCE_HUB_FAILURE';

const initialState = {
  loaded: false,
};

export default function audienceHubReducer(state = initialState, action) {
  switch (action.type) {
    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign(
        {},
        {
          error: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    default:
      return state;
  }
}

export function fetchAudienceHubSuccess(data) {
  return { type: SUCCESS, data };
}

export function fetchAudienceHubFailure(data) {
  return { type: FAILURE, data };
}

export function fetchAudienceHubAction() {
  return function (dispatch, getState, { Api, i18n }) {
    const {
      pageConfig: { previewMode, siteId, siteTypePath },
    } = getState();

    return Api()
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchAudienceHub({ siteId, siteTypePath })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchAudienceHubSuccess(response));
        } else {
          return dispatch(fetchAudienceHubFailure(response));
        }
      });
  };
}
